import { HashRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './Components/Layout/Layout';
import Home from './Components/Home/Home';
import About from './Components/About/About';
import Contact from './Components/Contact/Contact';
import Partners from './Components/Partners/Partners';
import Courses from './Components/Courses/Courses';
import CourseDetails from './Components/Courses/CourseDetails';
import MediaCenter from './Components/MediaCenter/MediaCenter';
import Calender from './Components/Calender/Calender';
import RegistraionForm from './Components/Courses/RegistraionForm';

function App() {

  return <>
    <HashRouter>
      <Routes>
        <Route
          path="/"
          element={<Layout />}>
          <Route index element={<Home />} />
          <Route path={`about`} element={<About />} />
          <Route path={`courses`} element={<Courses />} />
          <Route path={`courses/:course_name/:course_id`} element={<CourseDetails />} />
          <Route path={`courses/:course_name/:course_id/register`} element={<RegistraionForm />} />
          <Route path={`our-parnters`} element={<Partners />} />
          <Route path={`training-events-calender`} element={<Calender />} />
          <Route path={`contact-us`} element={<Contact />} />
        </Route>
        <Route path={`media-center`} element={<MediaCenter />} />

      </Routes>
    </HashRouter>
  </>
}

export default App;
